import { $fetch } from '@/boot/fetch'

function endpoint(retailerId) {
  return `/retailers/${retailerId}/notification-preferences`
}

export default {
  get(retailerId) {
    return $fetch.peg(endpoint(retailerId))
  },
  update(retailerId, preferences) {
    return $fetch.peg(endpoint(retailerId), { method: 'PUT', body: preferences })
  },
}
